// 1.引入路由以及vue，下面的是固定写法，照写就可以
import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { // 根路径
      path: '/',
      redirect: '/mycourses',
      component: () => import('@/views/course/mycourses')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/user/login')
    },
    {
      path: '/mycourses',
      name: 'mycourses',
      component: () => import('@/views/course/mycourses')
    },
    {
      path: '/union',
      name: 'union',
      component: () => import('@/views/course/union')
    },
    {
      path: '/article',
      name: 'article',
      component: () => import('@/views/course/article')
    },
    {
      path: '/privacyPolicy',
      name: 'privacyPolicy',
      component: () => import('@/views/privacy/privacy-policy')
    }, {
      path: '/permit',
      name: 'permit',
      component: () => import('@/views/privacy/permit')
    }, {
      path: '/canvas',
      name: 'canvas',
      component: () => import('@/views/canvas/canvas')
    }
    ]
})

/* 路由拦截器 路由跳转前的操作 */
router.beforeEach((to, from, next) => {
  let _token = sessionStorage.getItem("token")
  let require = to.matched.some(function (item) {      // 是否需要登录
    return item.meta.isLogin
  })
  console.log(require)
  console.log("登录")
  console.log(to)
  console.log(from)
  console.log(_token)
  if (to.name == 'permit' || to.name == 'privacyPolicy') {
    next()
  } else {
    if (!_token && require) {       // 当未登录，且跳转的页面需要登录后才能操作时，进行路由拦截
      next({                          // 跳转登录页
        name: "login",
        params: { redirect: to }      // 将 要跳转（即被拦截） 的路由对象，作为参数，传递到登录页面
      });
    } else {    
      console.log("百度统计")
      console.log(_hmt)  
      if (_hmt) {
        if (to.path) {
          // eslint-disable-next-line
          _hmt.push(['_trackPageview', to.path]);
        }
      }                          // 已登录就正常跳转，不做任何拦截
      next()                          // 正常跳转到下一页
    }
  }
})
/* 路由拦截器 路由跳转后的操作 */
router.afterEach(to => {
  
})


export default router